import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import HSCode from '~/containers/hsCode/hsCode';

export class IngredientPage extends Component {
  state = {
    hsCode: null
  };

  onReceiveCode = ({ hsCode }) => {
    this.setState({
      hsCode
    });
  };

  render() {
    const hsCodeId = this.props.match.params.hsCodeId;
    const { hsCode } = this.state;

    const editButton = (
      <Link to={`/settings/hsCodes/${hsCodeId}/edit`}>
        <Button data-qa="hsCode-edit" color="primary">
          Edit
        </Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar
          back="/settings/hsCodes"
          backText="HS Codes"
          title={hsCode ? hsCode.name : '...'}
          button={editButton}
        />
        <HSCode onCompleted={this.onReceiveCode} id={hsCodeId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(IngredientPage));



// WEBPACK FOOTER //
// ./src/pages/hsCode/hsCode.jsx